import { useCallback, useMemo, useState } from 'react'
import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import { useSectionId } from '@v4/components/common/SectionItem'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import useRepeatableMetaData from '@v4/hooks/useRepeatableMetaData'
import { useMediaQuery, useTheme } from '@material-ui/core'
import useStyles from './Video9.styled'

export const useVideo9 = props => {
	const { metaData } = props
	const sectionId = useSectionId()
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
	const classes = useStyles(props)

	const group = 'items'

	const items = PageBuilderSelector.useRepeatableGroupKeys({
		sectionId,
		group,
	})

	const { handleFocus: handleTitleClick } = useFieldFocus({ metaData: metaData.title })
	const { editable: titleEditable, handleChange: handleTitleChange } = useEditorMeta({
		metaData: metaData.title,
		key: 'title',
	})

	const activeItemKey = PageBuilderSelector.useMetaActiveItemKey({
		sectionId,
		group,
	})

	const activeItemIndex = useMemo(() => {
		const index = _.findIndex(items, item => item === activeItemKey)

		return index !== -1 ? index : 0
	}, [activeItemKey, items])

	const itemMetaData = useRepeatableMetaData({ group, index: activeItemIndex })

	const [watchedItems, setWatchedItems] = useState(() =>
		activeItemKey
			? {
					[activeItemKey]: true,
			  }
			: {},
	)

	const handleVideoClick = useCallback(
		itemKey => {
			if (!watchedItems[itemKey]) {
				setWatchedItems({ ...watchedItems, [itemKey]: true })
			}
		},
		[watchedItems],
	)

	return [
		{
			classes,
			items,
			watchedItems,
			activeItemKey,
			isMobile,
			mobileAlignment: metaData.mobileAlignment?.metaValue,
			video: itemMetaData?.itemVideo,

			title: metaData.title?.metaValue,
			titleConfig: metaData.title?.config,
			titleKey: metaData.title?.tierKey,
			titleEditable,
		},
		{ handleTitleClick, handleTitleChange, handleVideoClick },
	]
}
